
import {
  defineComponent, reactive, watch,
  computed,
} from 'vue';
import { Modal } from 'ant-design-vue';
import Icone from '@/core/components/Icone.vue';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import ServicoEngenhariaProduto from '@/servicos/Cadastros/PCP/ServicoEngenhariaProduto';
import { IEngenhariaProduto } from '@/models/Entidades/Cadastros/PCP/IEngenhariaProduto';
import SelecionarTipoProducao from '@/components/Cadastros/PCP/SelecionarTipoProducao.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import { useGradeBase } from '@/core/composables/GradeBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import SelecionarUnidadeProdutoMovimento from '@/components/Cadastros/Produtos/Unidades/SelecionarUnidadeProdutoMovimento.vue';
import ServicoOrdemProducao from '@/servicos/PCP/ServicoOrdemProducao';
import { IOrdemProducao, IOrdemProducaoEtapa, IOrdemProducaoMateriaPrima } from '@/models/Entidades/PCP/IOrdemProducao';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import SelecionarEngenhariaProducao from '@/components/Cadastros/PCP/SelecionarEngenhariaProducao.vue';
import { EStatusProducao } from '@/models/Enumeradores/PCP/EStatusProducao';
import OrdemProducaoEtapas from '@/components/PCP/OrdemProducaoEtapas.vue';
import { ITipoProducao } from '@/models/Entidades/Cadastros/PCP/ITipoProducao';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import ServicoUnidade from '@/servicos/Cadastros/Produtos/ServicoUnidade';
import { IUnidade } from '@/models/Entidades/Cadastros/Produtos/IUnidade';
import { IParametrosConsultaOP } from '@/models/ParametrosRequisicao/PCP/IParametrosConsultaOP';
import { IApontamentoMateriaPrima, IApontamentoProducao } from '@/models/Entidades/PCP/IApontamentoProducao';
import { ETipoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoRastreabilidade';
import ServicoTipoProducao from '@/servicos/Cadastros/PCP/ServicoTipoProducao';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import { ETipoLancamentoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoLancamentoRastreabilidade';
import { IMovimentoRastreabilidade, IRastreabilidade, IRastreabilidadeOrigem } from '@/models/Entidades/Estoques/IRastreabilidade';
import ServicoRastreabilidade from '@/servicos/Estoques/ServicoRastreabilidade';
import { IDTORastreabilidade } from '@/models/DTO/Estoques/Rastreabilidade/IDTORastreabilidade';
import { ETipoUsoArma } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoUsoArma';
import { ETipoEtiqueta } from '@/models/Enumeradores/ETipoEtiqueta';
import storeSistema from '@/store/storeSistema';
import { ETipoControleProducao } from '@/models/Enumeradores/Cadastros/PCP/ETipoControleProcucao';
import { IDTOSelecaoProduto } from '@/models/DTO/Estoques/IDTOSelecaoProduto';
import ConsultaProdutosModal from '@/components/Cadastros/Produtos/ConsultaProdutos/ConsultaProdutosModal.vue';

export default defineComponent({
  name: 'OrdemProducaoModal',
  props: {
    visivel: {
      type: Boolean,
    },
    operacao: {
      type: Object as () => ITelaOperacao,
      required: true,
    },
  },
  components: {
    Icone,
    RequisicaoModal,
    SelecionarTipoProducao,
    SelecionarUnidadeProdutoMovimento,
    CampoNumerico,
    OrdemProducaoEtapas,
    SelecionarData,
    SelecionarEngenhariaProducao,
    PreviewPdf,
    ConsultaProdutosModal,

  },
  emits: ['update:operacao', 'update:visivel', 'update:confirmacao'],
  setup(props, { emit }) {
    const {
      telaBase, obterPermissoes, preencherEmpresasComEstrategiaPermissaoDados, defineEmpresasSelecionadasCadastroCompartilhado,
      preencherPermissoesDados, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemSucesso, verificaConceitoParaApresentarEmpresas,
      apresentarMensagemErro, apresentarMensagemAlerta,
    } = useTelaBase();
    const {
      modalBase, apresentarRetornoRequisicao, apresentarBarraProgresso, ocultarBarraProgresso,
      defineTextoPadraoBotoes,
    } = useModalBase(props, emit);
    const {
      gradeBase,
    } = useGradeBase();

    const computedOperacao = computed({
      get: () => props.operacao,
      set: (val: ITelaOperacao) => {
        emit('update:operacao', val);
      },
    });
    const servicoEngenhariaProduto = new ServicoEngenhariaProduto();
    const servicoOrdemProducao = new ServicoOrdemProducao();
    const servicoUnidade = new ServicoUnidade();
    const servicoTipoProducao = new ServicoTipoProducao();
    const servicoRastreabilidade = new ServicoRastreabilidade();
    telaBase.identificadorRecurso = 'PCP_ORDEM_PRODUCAO';
    telaBase.identificadorPermissao = 'PER_PCP_ORDEM_PRODUCAO';
    servicoEngenhariaProduto.requisicaoSistema();
    servicoUnidade.requisicaoSistema();
    servicoTipoProducao.requisicaoSistema();

    const state = reactive({
      ordemProducao: {} as IOrdemProducao,
      engenharia: {} as IEngenhariaProduto,
      tipoProducao: {} as ITipoProducao,
      editavel: true,
      etapaSelecionada: 0,
      codigoProduto: 0,
      codigoItemEstoque: 0,
      codigoUnidade: 0,
      descricaoEngenharia: '',
      unidade: {} as IUnidade,
      exibirRastreabilidade: false,
      produtosSelecionados: [] as IDTOSelecaoProduto[],
      emDigitacao: false,
      corStatus: '',
      nomeStatus: '',
      arquivosPdf: [] as IArquivoPdf[],
      tipoRastreabilidade: ETipoRastreabilidade.Nenhum,
      tipoLancamento: 0,
      lancouRastreabilidades: false,
      selecaoUnica: false,
      lancamentoInicialMPProducao: false,
      rastreabilidadeMPUtilizada: [] as IRastreabilidade[],
      produtoAcabadoEditavel: true,
      quantidadeProduzirAnterior: 0,
      editarApontamentoMateriaPrima: false,
      criarApontamentoProdutoAcabado: false,
      estoqueRastreabilidadeUtilizado: [] as IDTORastreabilidade[],
      tipoSelecaoRastreabilidade: 0,
      abaAtiva: '1',
      atualizarControles: false,
      atualizarObservacao: false,
      alterouQuantidadeMP: false,
      alterouAptoTransferenciaLote: false,
      densidade: 0,
      concluirAposApontamento: false,
    });

    function objetoInicial() {
      state.tipoProducao = {} as ITipoProducao;
      state.ordemProducao = {} as IOrdemProducao;
      state.ordemProducao.apontamentosProducao = [] as IApontamentoProducao[];
      state.ordemProducao.etapasProducao = [] as IOrdemProducaoEtapa[];
      state.engenharia = {} as IEngenhariaProduto;
      state.unidade = {} as IUnidade;
      telaBase.empresasSelecionadas = [];
      state.editavel = true;
      state.codigoItemEstoque = 0;
      state.codigoProduto = 0;
      state.codigoUnidade = 0;
      state.descricaoEngenharia = '';
      state.exibirRastreabilidade = false;
      state.produtosSelecionados = [] as IDTOSelecaoProduto[];
      state.ordemProducao.codigo = 0;
      state.ordemProducao.dataCriacao = UtilitarioData.obterDataAtual();
      state.ordemProducao.status = EStatusProducao.Pendente;
      state.ordemProducao.transferirLote = false;
      state.produtoAcabadoEditavel = true;
      state.editarApontamentoMateriaPrima = false;
      state.criarApontamentoProdutoAcabado = false;
      state.tipoRastreabilidade = ETipoRastreabilidade.Nenhum;
      state.abaAtiva = '1';
      state.tipoSelecaoRastreabilidade = 0;
      state.atualizarControles = false;
      state.atualizarObservacao = false;
      state.alterouQuantidadeMP = false;
      state.alterouAptoTransferenciaLote = false;
      state.concluirAposApontamento = false;
      state.densidade = 0;
    }

    function obterStatus() {
      switch (state.ordemProducao.status) {
        case EStatusProducao.Pendente:
          state.nomeStatus = 'Pendente';
          state.corStatus = 'pendente';
          break;
        case EStatusProducao.Produzindo:
          state.nomeStatus = 'Produzindo';
          state.corStatus = 'baixado-parcialmente';
          break;
        case EStatusProducao.Concluido:
          state.nomeStatus = 'Concluído';
          state.corStatus = 'baixado';
          break;
        case EStatusProducao.Cancelado:
          state.nomeStatus = 'Cancelado';
          state.corStatus = 'excluido';
          break;
        default:
          state.nomeStatus = 'Interrompido';
          break;
      }
    }

    async function AtualizarTela() {
      telaBase.carregando = true;
      objetoInicial();
      if (modalBase.computedVisivel) {
        if (props.operacao.listaPermissoesDados.length > 0) {
          await preencherPermissoesDados(props.operacao.listaPermissoesDados);
        } else {
          await obterPermissoes(ETipoPermissao.Dados);
        }
        await preencherEmpresasComEstrategiaPermissaoDados(props.operacao.tipoPermissaoDados, true);

        defineTextoPadraoBotoes(props.operacao.tipoPermissaoDados);

        if (props.operacao.tipoPermissaoDados === EPermissaoDados.Visualizar || props.operacao.tipoPermissaoDados === EPermissaoDados.Alterar) {
          state.ordemProducao = await servicoOrdemProducao.obter(props.operacao.codigoRegistro, props.operacao.empresaSelecionada);
          state.unidade = await servicoUnidade.obter(state.ordemProducao.codigoUnidade, props.operacao.empresaSelecionada);
          state.tipoProducao = await servicoTipoProducao.obter(state.ordemProducao.codigoTipoProducao, props.operacao.empresaSelecionada);
          state.engenharia = await servicoEngenhariaProduto.obter(state.ordemProducao.codigoEngenharia, props.operacao.empresaSelecionada);
          state.ordemProducao.nome = state.engenharia.nome;
          state.ordemProducao.codigoEngenharia = state.engenharia.codigo;
          telaBase.empresasSelecionadas.push(state.ordemProducao.codigoEmpresa);
          state.editavel = state.ordemProducao.status === EStatusProducao.Pendente;
          state.produtoAcabadoEditavel = state.ordemProducao.status < EStatusProducao.Concluido;
          state.editarApontamentoMateriaPrima = state.ordemProducao.status === EStatusProducao.Produzindo;
          state.atualizarControles = false;
          const controleDensidade = state.ordemProducao.controlesProducao.filter((ctrl) => ctrl.tipoControle === ETipoControleProducao.Densidade);
          state.densidade = controleDensidade.length > 0 ? controleDensidade[0].valor || 0 : 0;
        } else {
          await defineEmpresasSelecionadasCadastroCompartilhado(props.operacao.empresaSelecionada);
        }
        obterStatus();
        telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
        verificaConceitoParaApresentarEmpresas();
      }
      telaBase.carregando = false;
    }

    async function concluirCriacaoOpQtdPorLote(rastreabilidades: IDTORastreabilidade[]) {
      let quantidade = 0;
      rastreabilidades.forEach((item) => {
        quantidade += item.qtdSelecionada;
      });
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      state.ordemProducao.quantidadeProduzir = quantidade;
      apresentarBarraProgresso();
      if (props.operacao.tipoPermissaoDados === EPermissaoDados.Incluir) {
        const parametros: IParametrosConsultaOP = {} as IParametrosConsultaOP;
        parametros.codigoEmpresa = props.operacao.empresaSelecionada;
        parametros.codigoEngenharia = state.ordemProducao.codigoEngenharia;
        parametros.codigoUnidade = state.ordemProducao.codigoUnidade;
        parametros.quantidadeProduzir = state.ordemProducao.quantidadeProduzir;
        retorno = await servicoOrdemProducao.criarPorEngenharia(parametros);
      }

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        state.ordemProducao = await servicoOrdemProducao.obter(retorno.codigoRegistro, props.operacao.empresaSelecionada);
        computedOperacao.value.codigoRegistro = state.ordemProducao.codigo;
        computedOperacao.value.tipoPermissaoDados = EPermissaoDados.Alterar;
        state.editarApontamentoMateriaPrima = true;
        let mpOPTransferirLote: IOrdemProducaoMateriaPrima | undefined;
        if (Array.isArray(state.ordemProducao.etapasProducao)) {
          state.ordemProducao.etapasProducao.some((etapa) => {
            if (Array.isArray(etapa.materiasPrimas)) {
              mpOPTransferirLote = etapa.materiasPrimas.find((mp) => mp.transferirLote === true);
              return !!mpOPTransferirLote;
            }
            return false;
          });
        }
        if (mpOPTransferirLote) {
          state.rastreabilidadeMPUtilizada[0].codigoItemMovimento = mpOPTransferirLote.codigo;
          const retornoRast : IRetornoRequisicao = await servicoRastreabilidade.lancarRastreabilidadeSaida('PCP_ORDEM_PRODUCAO_MP', state.rastreabilidadeMPUtilizada);
          if (retornoRast.status !== EStatusRetornoRequisicao.Sucesso) {
            apresentarRetornoRequisicao(retornoRast);
          }
          const retornoTransferirLote = await servicoOrdemProducao.TransferirLote(state.ordemProducao);
          if (retornoTransferirLote.status !== EStatusRetornoRequisicao.Sucesso) {
            apresentarRetornoRequisicao(retornoTransferirLote);
          }
          await AtualizarTela();
        }
        apresentarMensagemSucesso(retorno.mensagem);
        emit('update:confirmacao', retorno.codigoRegistro);
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    async function criarOPComQtdePorLote() {
      try {
        if (state.ordemProducao.codigo > 0) { return; }
        // Busca a primeira matéria-prima com transferirLote === true
        let mpTransferirLote: any = null;
        if (Array.isArray(state.engenharia.etapasProducao)) {
          state.engenharia.etapasProducao.some((etapa) => {
            if (Array.isArray(etapa.materiasPrimas)) {
              mpTransferirLote = etapa.materiasPrimas.find((mp) => mp.transferirLote === true);
              return !!mpTransferirLote;
            }
            return false;
          });
        }

        if (mpTransferirLote) {
          state.lancamentoInicialMPProducao = true;
          state.produtosSelecionados = [] as IDTOSelecaoProduto[];
          const produtoSelecionado = {} as IDTOSelecaoProduto;
          produtoSelecionado.codigoProdutoDefinicao = mpTransferirLote.codigoProduto;
          produtoSelecionado.codigoItem = 0;
          produtoSelecionado.quantidade = 0;
          state.produtosSelecionados.push(produtoSelecionado);
          state.tipoLancamento = ETipoLancamentoRastreabilidade.Manual;
          state.codigoItemEstoque = 0;
          state.selecaoUnica = true;
          state.lancouRastreabilidades = false;
          state.tipoSelecaoRastreabilidade = 2;
          state.exibirRastreabilidade = true;
          state.tipoLancamento = 1;
          state.tipoRastreabilidade = ETipoRastreabilidade.Lote;
        } else {
          return;
        }
      } catch (erro) {
        if (erro instanceof Error) {
          apresentarMensagemErro(erro.message);
        } else {
          apresentarMensagemErro(String(erro));
        }
      } finally {
        ocultarBarraProgresso();
      }
    }

    async function PreencherEngenhariaProduto() {
      state.engenharia = await servicoEngenhariaProduto.obter(state.ordemProducao.codigoEngenharia, props.operacao.empresaSelecionada);
      state.unidade = await servicoUnidade.obter(state.engenharia.codigoUnidade, props.operacao.empresaSelecionada);
      state.ordemProducao.codigoEngenharia = state.engenharia.codigo;
      state.ordemProducao.codigoProduto = state.engenharia.codigoProduto;
      state.ordemProducao.codigoUnidade = state.engenharia.codigoUnidade;
      state.ordemProducao.nome = state.engenharia.nome;
      criarOPComQtdePorLote();
    }

    async function PreencherApontamentosProducao() {
      const apontamentoProducao : IApontamentoProducao = {} as IApontamentoProducao;
      apontamentoProducao.codigoOrdemProducao = state.ordemProducao.codigo;
      apontamentoProducao.dataCriacao = UtilitarioData.obterDataAtual();
      apontamentoProducao.dataConclusao = UtilitarioData.obterDataAtual();
      state.ordemProducao.apontamentosProducao.push(apontamentoProducao);
    }

    async function concluirCriacaoApontamentoMp(rastreabilidades: IDTORastreabilidade[]) {
      state.estoqueRastreabilidadeUtilizado = rastreabilidades;
      for (let i = 0; i < state.ordemProducao.etapasProducao.length; i += 1) {
        const etapa = state.ordemProducao.etapasProducao[i];
        for (let j = 0; j < etapa.materiasPrimas.length; j += 1) {
          const mp = etapa.materiasPrimas[j];
          if (mp.produtoIntermediario && mp.materiasPrimasPI) {
            mp.materiasPrimasPI.forEach((subItem, subIndex) => {
              // eslint-disable-next-line no-param-reassign
              subItem.apontamentosMateriaPrima = [] as IApontamentoMateriaPrima[];
              rastreabilidades.forEach((item) => {
                if (item.codigoItem === subItem.codigo) {
                  const apontamentoMateriaPrima = {
                    codigo: 0,
                    codigoOPMateriaPrima: subItem.codigo,
                    dataCriacao: UtilitarioData.obterDataAtual(),
                    codigoProduto: subItem.codigoProduto,
                    codigoUnidade: subItem.codigoUnidade,
                    quantidade: item.qtdSelecionada,
                    rastreabilidades: [] as IRastreabilidade[],
                    codigoEstoqueItem: item.codigoItemEstoque,
                    codigoEmpresa: state.ordemProducao.codigoEmpresa,
                    codigoEstoque: item.codigoEstoque,
                    codigoCentroCusto: 0,
                    codigoMovimentoEstoque: 0,
                  };
                  if (subItem.tipoRastreabilidade === ETipoRastreabilidade.Lote) {
                    const rastreabilidade: IRastreabilidade = {
                      codigo: item.codigo,
                      codigoItemMovimento: 0,
                      codigoItemEstoque: item.codigoItemEstoque,
                      identificador: item.identificador,
                      descricao: item.descricao,
                      dataCriacao: UtilitarioData.obterDataAtual(),
                      tipo: ETipoRastreabilidade.Lote,
                      rastreabilidadeLote: {
                        codigo: item.codigo,
                        codigoRastreabilidade: item.codigo,
                        numeroLote: item.numeroLote,
                        dataFabricacao: item.dataFabricacao,
                        dataValidade: item.dataValidade,
                        precoMaximoConsumidor: item.precoMaximoConsumidor,
                        densidade: 0,
                        controles: item.controles,
                      },
                      visivel: true,
                      qtdRastreabilidade: item.qtdSelecionada,
                      observacao: '',
                      movimentoRastreabilidade: {} as IMovimentoRastreabilidade,
                      rastreabilidadeArmamento: {
                        codigo: 0, codigoRastreabilidade: 0, descricao: '', tipoUsoArma: ETipoUsoArma.UsoRestrito, numeroSerieArma: '', numeroSerieCano: '',
                      },
                      origem: {
                        quantidade: item.qtdSelecionada, codigo: 0, codigoRastreabilidade: 0, codigoMovimento: 0, recurso: '',
                      },
                    };
                    apontamentoMateriaPrima.rastreabilidades.push(rastreabilidade);
                  }
                  state.ordemProducao.etapasProducao[i].materiasPrimas[j].materiasPrimasPI[subIndex].apontamentosMateriaPrima.push(apontamentoMateriaPrima);
                }
              });
            });
          } else if (mp.transferirLote === false) {
            mp.apontamentosMateriaPrima = [] as IApontamentoMateriaPrima[];
            rastreabilidades.forEach((item) => {
              if (item.codigoItem === mp.codigo) {
                const apontamentoMateriaPrima = {
                  codigo: 0,
                  codigoOPMateriaPrima: mp.codigo,
                  dataCriacao: UtilitarioData.obterDataAtual(),
                  codigoProduto: mp.codigoProduto,
                  codigoUnidade: mp.codigoUnidade,
                  quantidade: item.qtdSelecionada,
                  rastreabilidades: [] as IRastreabilidade[],
                  codigoEstoqueItem: item.codigoItemEstoque,
                  codigoEmpresa: state.ordemProducao.codigoEmpresa,
                  codigoEstoque: item.codigoEstoque,
                  codigoCentroCusto: 0,
                  codigoMovimentoEstoque: 0,
                };
                if (mp.tipoRastreabilidade === ETipoRastreabilidade.Lote) {
                  const rastreabilidade: IRastreabilidade = {
                    codigo: item.codigo,
                    codigoItemMovimento: 0,
                    codigoItemEstoque: item.codigoItemEstoque,
                    identificador: item.identificador,
                    descricao: item.descricao,
                    dataCriacao: UtilitarioData.obterDataAtual(),
                    tipo: ETipoRastreabilidade.Lote,
                    rastreabilidadeLote: {
                      codigo: item.codigo,
                      codigoRastreabilidade: item.codigo,
                      numeroLote: item.numeroLote,
                      dataFabricacao: item.dataFabricacao,
                      dataValidade: item.dataValidade,
                      precoMaximoConsumidor: item.precoMaximoConsumidor,
                      densidade: 0,
                      controles: item.controles, // eslint-disable-next-line max-len
                    },
                    visivel: true,
                    qtdRastreabilidade: item.qtdSelecionada,
                    observacao: '',
                    movimentoRastreabilidade: {} as IMovimentoRastreabilidade,
                    rastreabilidadeArmamento: {
                      codigo: 0,
                      codigoRastreabilidade: 0,
                      descricao: '',
                      tipoUsoArma: ETipoUsoArma.UsoRestrito,
                      numeroSerieArma: '',
                      numeroSerieCano: '',
                    },
                    origem: {
                      quantidade: item.qtdSelecionada,
                      codigo: 0,
                      codigoRastreabilidade: 0,
                      codigoMovimento: 0,
                      recurso: '',
                    },
                  };
                  apontamentoMateriaPrima.rastreabilidades.push(rastreabilidade);
                }
                state.ordemProducao.etapasProducao[i].materiasPrimas[j].apontamentosMateriaPrima.push(apontamentoMateriaPrima);
              }
            });
            state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
          }
        }
      }
      apresentarBarraProgresso();
      try {
        const retorno = await servicoOrdemProducao.iniciar(state.ordemProducao);

        if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
          await AtualizarTela();
          state.criarApontamentoProdutoAcabado = true;
          apresentarMensagemSucesso('Ordem de produção iniciada com sucesso.');
        } else {
          apresentarRetornoRequisicao(retorno);
        }
      } catch (erro) {
        if (erro instanceof Error) {
          apresentarMensagemErro(erro.message);
        } else {
          apresentarMensagemErro(String(erro));
        }
      }
    }

    async function CriarApontamentoMateriaPrima() {
      try {
        state.produtosSelecionados = [] as IDTOSelecaoProduto[];
        for (let i = 0; i < state.ordemProducao.etapasProducao.length; i += 1) {
          const etapa = state.ordemProducao.etapasProducao[i];
          for (let j = 0; j < etapa.materiasPrimas.length; j += 1) {
            const mp = etapa.materiasPrimas[j];
            if (mp.transferirLote === false && !mp.produtoIntermediario) {
              const produtoSelecionado = {} as IDTOSelecaoProduto;
              produtoSelecionado.codigoProdutoDefinicao = mp.codigoProduto;
              produtoSelecionado.codigoItem = mp.codigo;
              produtoSelecionado.quantidade = mp.quantidade;
              state.tipoRastreabilidade = mp.tipoRastreabilidade;
              state.tipoLancamento = mp.tipoLancamentoRastreabilidade;
              state.codigoItemEstoque = mp.estoqueItem;
              state.selecaoUnica = false;
              state.lancouRastreabilidades = false;
              state.lancamentoInicialMPProducao = false;
              state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
              state.produtosSelecionados.push(produtoSelecionado);
              mp.apontamentosMateriaPrima = [] as IApontamentoMateriaPrima[];
              state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
            } else if (mp.produtoIntermediario && mp.materiasPrimasPI) {
              mp.materiasPrimasPI.forEach((subItem) => {
                const produtoSelecionado = {} as IDTOSelecaoProduto;
                produtoSelecionado.codigoProdutoDefinicao = subItem.codigoProduto;
                produtoSelecionado.codigoItem = subItem.codigo;
                produtoSelecionado.quantidade = subItem.quantidade;
                state.produtosSelecionados.push(produtoSelecionado);
                // eslint-disable-next-line no-param-reassign
                subItem.apontamentosMateriaPrima = [];
              });
            }
          }
        }
        if (state.produtosSelecionados.length === 0) {
          await concluirCriacaoApontamentoMp(state.estoqueRastreabilidadeUtilizado);
        } else {
          state.tipoSelecaoRastreabilidade = 3;
          state.exibirRastreabilidade = true;
        }
      } catch (erro) {
        if (erro instanceof Error) {
          apresentarMensagemErro(erro.message);
        } else {
          apresentarMensagemErro(String(erro));
        }
        return false;
      }
      return true;
    }

    async function ValidaApontamentoProdutoAcabado() {
      for (let i = 0; i < state.ordemProducao.etapasProducao.length; i += 1) {
        const etapas = state.ordemProducao.etapasProducao[i];
        for (let j = 0; j < etapas.produtosAcabados.length; j += 1) {
          const pa = etapas.produtosAcabados[j];
          if (!UtilitarioGeral.validaLista(pa.apontamentosProdutoAcabado)) {
            state.criarApontamentoProdutoAcabado = true;
            apresentarMensagemErro('O apontamento do Produto Acabado é obrigatório e foi criado. por favor repita o processo de conclusão da produção.');
            return false;
          }
        }
      }
      return true;
    }

    async function IniciarOrdemProducao() {
      if (state.ordemProducao.status !== EStatusProducao.Pendente) {
        apresentarMensagemAlerta('A ordem de produção só pode ser iniciada se estiver no status "Pendente".');
        return;
      }
      await CriarApontamentoMateriaPrima();
    }

    async function ConcluirProducao() {
      PreencherApontamentosProducao();
      if (!(await ValidaApontamentoProdutoAcabado())) { return; }
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      apresentarBarraProgresso();
      try {
        retorno = await servicoOrdemProducao.concluir(state.ordemProducao);
        if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
          ocultarBarraProgresso();
          await AtualizarTela();
          state.editavel = false;
          emit('update:confirmacao');
          apresentarMensagemSucesso(retorno.mensagem);
        } else {
          ocultarBarraProgresso();
          apresentarRetornoRequisicao(retorno);
        }
      } catch (erro) {
        if (erro instanceof Error) {
          apresentarMensagemErro(erro.message);
        } else {
          apresentarMensagemErro(String(erro));
        }
      }
    }

    function verificarAlteracaoApontamentos(): boolean {
      return state.ordemProducao.etapasProducao.some((etapa) => etapa.materiasPrimas.some((mp) => {
        if (mp.produtoIntermediario && Array.isArray(mp.materiasPrimasPI)) {
          return mp.materiasPrimasPI.some((pi) => {
            const qtdApontadaPI = Array.isArray(pi.apontamentosMateriaPrima)
              ? pi.apontamentosMateriaPrima.reduce((acc, curr) => acc + curr.quantidade, 0) : 0;
            return qtdApontadaPI !== pi.quantidade;
          });
        }
        const qtdApontada = Array.isArray(mp.apontamentosMateriaPrima)
          ? mp.apontamentosMateriaPrima.reduce((acc, curr) => acc + curr.quantidade, 0) : 0;
        if (!mp.produtoIntermediario && qtdApontada !== mp.quantidade) {
          return true;
        }
        return false;
      }));
    }

    async function CriarApontamentoMPAdicionada() {
      try {
        state.produtosSelecionados = [] as IDTOSelecaoProduto[];
        for (let i = 0; i < state.ordemProducao.etapasProducao.length; i += 1) {
          const etapa = state.ordemProducao.etapasProducao[i];
          for (let j = 0; j < etapa.materiasPrimas.length; j += 1) {
            const mp = etapa.materiasPrimas[j];
            if (!mp.produtoIntermediario && (mp.apontamentosMateriaPrima.length === 0 || mp.apontamentosMateriaPrima.reduce((acc, curr) => acc + curr.quantidade, 0) !== mp.quantidade)) {
              const produtoSelecionado = {} as IDTOSelecaoProduto;
              produtoSelecionado.codigoProdutoDefinicao = mp.codigoProduto;
              produtoSelecionado.codigoItem = mp.codigo;
              produtoSelecionado.quantidade = mp.quantidade;
              produtoSelecionado.estoqueRastPrevio = mp.apontamentosMateriaPrima.map((apontamento) => ({
                codigoItem: mp.codigo,
                codigoItemNotaFiscal: 0,
                codigoProdutoDefinicao: apontamento.codigoProduto,
                codigoMovimento: apontamento.codigo,
                codigoEstoque: apontamento.codigoEstoque,
                descricaoEstoque: '',
                descricao: '',
                identificador: apontamento.rastreabilidades?.[0]?.identificador || '',
                quantidade: apontamento.quantidade,
                tipo: apontamento.rastreabilidades?.[0]?.tipo || 0,
                saldo: 0,
                codigoProduto: String(apontamento.codigoProduto),
                descricaoProduto: '',
                unidade: '',
                codigoItemEstoque: apontamento.codigoEstoqueItem,
                codigo: apontamento.rastreabilidades?.[0]?.codigo || apontamento.codigoEstoqueItem,
                numeroLote: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.numeroLote || '',
                dataValidade: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.dataValidade || '',
                dataFabricacao: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.dataFabricacao || '',
                observacao: apontamento.rastreabilidades?.[0]?.observacao || '',
                dataVencimentoFormatada: '',
                dataFabricacaoFormatada: '',
                precoMaximoConsumidor: 0,
                descricaoArmamento: '',
                TipoUsoArma: ETipoUsoArma.UsoPermitido,
                numeroSerieArma: '',
                numeroSerieCano: '',
                casasDecimais: 0,
                qtdSelecionada: apontamento.quantidade,
                qtdAjuste: 0,
                qtdAjustada: 0,
                visivel: true,
                controles: [],
              }));
              state.tipoRastreabilidade = mp.tipoRastreabilidade;
              state.tipoLancamento = mp.transferirLote === false ? mp.tipoLancamentoRastreabilidade : ETipoLancamentoRastreabilidade.Manual;
              state.codigoItemEstoque = mp.estoqueItem;
              state.alterouQuantidadeMP = true;
              state.selecaoUnica = false;
              state.lancouRastreabilidades = false;
              state.lancamentoInicialMPProducao = false;
              state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
              state.produtosSelecionados.push(produtoSelecionado);
            }
            if (mp.produtoIntermediario && Array.isArray(mp.materiasPrimasPI)) {
              mp.materiasPrimasPI.forEach((pi) => {
                if (pi.apontamentosMateriaPrima.length === 0 || pi.apontamentosMateriaPrima.reduce((acc, curr) => acc + curr.quantidade, 0) !== pi.quantidade) {
                  const produtoSelecionado = {} as IDTOSelecaoProduto;
                  produtoSelecionado.codigoProdutoDefinicao = pi.codigoProduto;
                  produtoSelecionado.codigoItem = pi.codigo;
                  produtoSelecionado.quantidade = pi.quantidade;
                  produtoSelecionado.estoqueRastPrevio = pi.apontamentosMateriaPrima.map((apontamento) => ({
                    codigoItem: pi.codigo,
                    codigoItemNotaFiscal: 0,
                    codigoProdutoDefinicao: apontamento.codigoProduto,
                    codigoMovimento: apontamento.codigo,
                    codigoEstoque: apontamento.codigoEstoque,
                    descricaoEstoque: '',
                    descricao: '',
                    identificador: apontamento.rastreabilidades?.[0]?.identificador || '',
                    quantidade: apontamento.quantidade,
                    tipo: apontamento.rastreabilidades?.[0]?.tipo || 0,
                    saldo: 0,
                    codigoProduto: String(apontamento.codigoProduto),
                    descricaoProduto: '',
                    unidade: '',
                    codigoItemEstoque: apontamento.codigoEstoqueItem,
                    codigo: apontamento.rastreabilidades?.[0]?.codigo || apontamento.codigoEstoqueItem,
                    numeroLote: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.numeroLote || '',
                    dataValidade: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.dataValidade || '',
                    dataFabricacao: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.dataFabricacao || '',
                    observacao: apontamento.rastreabilidades?.[0]?.observacao || '',
                    dataVencimentoFormatada: '',
                    dataFabricacaoFormatada: '',
                    precoMaximoConsumidor: 0,
                    descricaoArmamento: '',
                    TipoUsoArma: ETipoUsoArma.UsoPermitido,
                    numeroSerieArma: '',
                    numeroSerieCano: '',
                    casasDecimais: 0,
                    qtdAjuste: 0,
                    qtdAjustada: 0,
                    visivel: true,
                    controles: [],
                    qtdSelecionada: apontamento.quantidade,
                  }));
                  state.tipoRastreabilidade = pi.tipoRastreabilidade;
                  state.tipoLancamento = pi.tipoLancamentoRastreabilidade;
                  state.alterouQuantidadeMP = true;
                  state.produtosSelecionados.push(produtoSelecionado);
                }
              });
            }
            state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
          }
        }
        state.exibirRastreabilidade = true;
        state.tipoSelecaoRastreabilidade = 3;
      } catch (erro) {
        if (erro instanceof Error) {
          apresentarMensagemErro(erro.message);
        } else {
          apresentarMensagemErro(String(erro));
        }
        return false;
      } finally {
        ocultarBarraProgresso();
      }
      return true;
    }

    async function validarConclusao(ignorarVerificacaoApontamento = false) {
      if (!ignorarVerificacaoApontamento) {
        if (verificarAlteracaoApontamentos()) {
          state.concluirAposApontamento = true;
          await CriarApontamentoMPAdicionada();
          return;
        }
      }

      const densidadeControle = state.ordemProducao.controlesProducao.find((controle) => controle.tipoControle === ETipoControleProducao.Densidade);
      if (densidadeControle && densidadeControle.valor === 0) {
        Modal.confirm({
          title: 'Densidade não informada',
          content: 'Não foi informado o valor para o controle de densidade. Deseja informar agora?',
          okText: 'Sim',
          cancelText: 'Não',
          onOk() {
            state.abaAtiva = '3';
          },
          onCancel() {
            ConcluirProducao();
          },
        });
      } else {
        ConcluirProducao();
      }
    }

    async function ConcluirCriacaoApontamentoMPAdicionada(rastreabilidades: IDTORastreabilidade[]) {
      for (let i = 0; i < state.ordemProducao.etapasProducao.length; i += 1) {
        const etapa = state.ordemProducao.etapasProducao[i];
        for (let j = 0; j < etapa.materiasPrimas.length; j += 1) {
          const mp = etapa.materiasPrimas[j];
          const qtdApurada = rastreabilidades.filter((item) => item.codigoItem === mp.codigo).reduce((acc, curr) => acc + curr.qtdSelecionada, 0);
          if (mp.apontamentosMateriaPrima.length === 0 || (qtdApurada !== mp.apontamentosMateriaPrima.reduce((acc, curr) => acc + curr.quantidade, 0) && qtdApurada > 0)) {
            mp.apontamentosMateriaPrima = [] as IApontamentoMateriaPrima[];
            state.estoqueRastreabilidadeUtilizado = rastreabilidades.filter((item) => item.codigoItem === mp.codigo);
            state.estoqueRastreabilidadeUtilizado.forEach((item) => {
              const apontamentoMateriaPrima = {
                codigo: item.codigoMovimento,
                codigoOPMateriaPrima: mp.codigo,
                dataCriacao: UtilitarioData.obterDataAtual(),
                codigoProduto: mp.codigoProduto,
                codigoUnidade: mp.codigoUnidade,
                quantidade: item.qtdSelecionada,
                rastreabilidades: [] as IRastreabilidade[],
                codigoEstoqueItem: item.codigoItemEstoque,
                codigoEmpresa: state.ordemProducao.codigoEmpresa,
                codigoEstoque: item.codigoEstoque,
                codigoCentroCusto: 0,
                codigoMovimentoEstoque: 0,
              };
              if (mp.tipoRastreabilidade === ETipoRastreabilidade.Lote) {
                const rastreabilidade: IRastreabilidade = {
                  codigo: item.codigo,
                  codigoItemMovimento: item.codigoMovimento,
                  codigoItemEstoque: item.codigoItemEstoque,
                  identificador: item.identificador,
                  descricao: item.descricao,
                  dataCriacao: UtilitarioData.obterDataAtual(),
                  tipo: ETipoRastreabilidade.Lote,
                  rastreabilidadeLote: {
                    codigo: item.codigo,
                    codigoRastreabilidade: item.codigo,
                    numeroLote: item.numeroLote,
                    dataFabricacao: item.dataFabricacao,
                    dataValidade: item.dataValidade,
                    precoMaximoConsumidor: item.precoMaximoConsumidor,
                    densidade: 0,
                    controles: item.controles,
                  },
                  visivel: true,
                  qtdRastreabilidade: item.qtdSelecionada,
                  observacao: '',
                  movimentoRastreabilidade: {} as IMovimentoRastreabilidade,
                  rastreabilidadeArmamento: {
                    codigo: 0,
                    codigoRastreabilidade: 0,
                    descricao: '',
                    tipoUsoArma: ETipoUsoArma.UsoRestrito,
                    numeroSerieArma: '',
                    numeroSerieCano: '',
                  },
                  origem: {
                    quantidade: item.qtdSelecionada,
                    codigo: 0,
                    codigoRastreabilidade: 0,
                    codigoMovimento: 0,
                    recurso: '',
                  },
                };
                mp.estoque = item.codigoEstoque;
                mp.estoqueItem = item.codigoItemEstoque;
                apontamentoMateriaPrima.rastreabilidades.push(rastreabilidade);
              }
              mp.apontamentosMateriaPrima.push(apontamentoMateriaPrima);
            });
            state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
          }
          if (mp.produtoIntermediario && Array.isArray(mp.materiasPrimasPI)) {
            mp.materiasPrimasPI.forEach((pi) => {
              const qtdApuradaPI = rastreabilidades.filter((item) => item.codigoItem === pi.codigo).reduce((acc, curr) => acc + curr.qtdSelecionada, 0);
              if (pi.apontamentosMateriaPrima.length === 0 || (qtdApuradaPI !== pi.apontamentosMateriaPrima.reduce((acc, curr) => acc + curr.quantidade, 0) && qtdApuradaPI > 0)) {
                // eslint-disable-next-line no-param-reassign
                pi.quantidade = qtdApuradaPI;
                // eslint-disable-next-line no-param-reassign
                pi.apontamentosMateriaPrima = [] as IApontamentoMateriaPrima[];
                const estoqueRastUtilizadoPI = rastreabilidades.filter((item) => item.codigoItem === pi.codigo);
                estoqueRastUtilizadoPI.forEach((item) => {
                  const apontamentoMateriaPrima = {
                    codigo: item.codigoMovimento,
                    codigoOPMateriaPrima: pi.codigo,
                    dataCriacao: UtilitarioData.obterDataAtual(),
                    codigoProduto: pi.codigoProduto,
                    codigoUnidade: pi.codigoUnidade,
                    quantidade: item.qtdSelecionada,
                    rastreabilidades: [] as IRastreabilidade[],
                    codigoEstoqueItem: item.codigoItemEstoque,
                    codigoEmpresa: state.ordemProducao.codigoEmpresa,
                    codigoEstoque: item.codigoEstoque,
                    codigoCentroCusto: 0,
                    codigoMovimentoEstoque: 0,
                  };
                  if (pi.tipoRastreabilidade === ETipoRastreabilidade.Lote) {
                    const rastreabilidade: IRastreabilidade = {
                      codigo: item.codigo,
                      codigoItemMovimento: item.codigoMovimento,
                      codigoItemEstoque: item.codigoItemEstoque,
                      identificador: item.identificador,
                      descricao: item.descricao,
                      dataCriacao: UtilitarioData.obterDataAtual(),
                      tipo: ETipoRastreabilidade.Lote,
                      rastreabilidadeLote: {
                        codigo: item.codigo,
                        codigoRastreabilidade: item.codigo,
                        numeroLote: item.numeroLote,
                        dataFabricacao: item.dataFabricacao,
                        dataValidade: item.dataValidade,
                        precoMaximoConsumidor: item.precoMaximoConsumidor,
                        densidade: 0,
                        controles: item.controles,
                      },
                      visivel: true,
                      qtdRastreabilidade: item.qtdSelecionada,
                      observacao: '',
                      movimentoRastreabilidade: {} as IMovimentoRastreabilidade,
                      rastreabilidadeArmamento: {
                        codigo: 0, codigoRastreabilidade: 0, descricao: '', tipoUsoArma: ETipoUsoArma.UsoRestrito, numeroSerieArma: '', numeroSerieCano: '',
                      },
                      origem: {
                        quantidade: item.qtdSelecionada, codigo: 0, codigoRastreabilidade: 0, codigoMovimento: 0, recurso: '',
                      },
                    };
                    // eslint-disable-next-line no-param-reassign
                    pi.estoque = item.codigoEstoque;
                    // eslint-disable-next-line no-param-reassign
                    pi.estoqueItem = item.codigoItemEstoque;
                    apontamentoMateriaPrima.rastreabilidades.push(rastreabilidade);
                  }
                  pi.apontamentosMateriaPrima.push(apontamentoMateriaPrima);
                });
              }
            });
          }
        }
      }
      if (state.alterouQuantidadeMP) {
        try {
          const retorno = await servicoOrdemProducao.alterar(state.ordemProducao);
          if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
            state.criarApontamentoProdutoAcabado = true;
            if (state.concluirAposApontamento) {
              await validarConclusao();
              state.concluirAposApontamento = false;
            } else {
              await AtualizarTela();
              apresentarMensagemSucesso('Ordem de produção iniciada com sucesso.');
              ocultarBarraProgresso();
            }
          } else {
            apresentarRetornoRequisicao(retorno);
          }
        } catch (erro) {
          if (erro instanceof Error) {
            apresentarMensagemErro(erro.message);
          } else {
            apresentarMensagemErro(String(erro));
          }
        }
      }
    }

    async function ConcluirCriacaoApontamentoMPTransferenciaLote(rastreabilidades: IDTORastreabilidade[]) {
      for (let i = 0; i < state.ordemProducao.etapasProducao.length; i += 1) {
        const etapa = state.ordemProducao.etapasProducao[i];
        for (let j = 0; j < etapa.materiasPrimas.length; j += 1) {
          const mp = etapa.materiasPrimas[j];
          if (mp.transferirLote === true) {
            const qtdApurada = rastreabilidades.filter((item) => item.codigoItem === mp.codigo).reduce((acc, curr) => acc + curr.qtdSelecionada, 0);
            if (mp.apontamentosMateriaPrima.length === 0 || (qtdApurada !== mp.apontamentosMateriaPrima.reduce((acc, curr) => acc + curr.quantidade, 0) && qtdApurada > 0)) {
              mp.apontamentosMateriaPrima = [] as IApontamentoMateriaPrima[];
              state.estoqueRastreabilidadeUtilizado = rastreabilidades.filter((item) => item.codigoItem === mp.codigo);
              state.estoqueRastreabilidadeUtilizado.forEach((item) => {
                const apontamentoMateriaPrima = {
                  codigo: item.codigoMovimento,
                  codigoOPMateriaPrima: mp.codigo,
                  dataCriacao: UtilitarioData.obterDataAtual(),
                  codigoProduto: mp.codigoProduto,
                  codigoUnidade: mp.codigoUnidade,
                  quantidade: item.qtdSelecionada,
                  rastreabilidades: [] as IRastreabilidade[],
                  codigoEstoqueItem: item.codigoItemEstoque,
                  codigoEmpresa: state.ordemProducao.codigoEmpresa,
                  codigoEstoque: item.codigoEstoque,
                  codigoCentroCusto: 0,
                  codigoMovimentoEstoque: 0,
                };
                if (mp.tipoRastreabilidade === ETipoRastreabilidade.Lote) {
                  const rastreabilidade: IRastreabilidade = {
                    codigo: item.codigo,
                    codigoItemMovimento: item.codigoMovimento,
                    codigoItemEstoque: item.codigoItemEstoque,
                    identificador: item.identificador,
                    descricao: item.descricao,
                    dataCriacao: UtilitarioData.obterDataAtual(),
                    tipo: ETipoRastreabilidade.Lote,
                    rastreabilidadeLote: {
                      codigo: item.codigo,
                      codigoRastreabilidade: item.codigo,
                      numeroLote: item.numeroLote,
                      dataFabricacao: item.dataFabricacao,
                      dataValidade: item.dataValidade,
                      precoMaximoConsumidor: item.precoMaximoConsumidor,
                      densidade: 0,
                      controles: item.controles,
                    },
                    visivel: true,
                    qtdRastreabilidade: item.qtdSelecionada,
                    observacao: '',
                    movimentoRastreabilidade: {} as IMovimentoRastreabilidade,
                    rastreabilidadeArmamento: {
                      codigo: 0,
                      codigoRastreabilidade: 0,
                      descricao: '',
                      tipoUsoArma: ETipoUsoArma.UsoRestrito,
                      numeroSerieArma: '',
                      numeroSerieCano: '',
                    },
                    origem: {
                      quantidade: item.qtdSelecionada,
                      codigo: 0,
                      codigoRastreabilidade: 0,
                      codigoMovimento: 0,
                      recurso: '',
                    },
                  };
                  mp.estoque = item.codigoEstoque;
                  mp.estoqueItem = item.codigoItemEstoque;
                  apontamentoMateriaPrima.rastreabilidades.push(rastreabilidade);
                }
                mp.apontamentosMateriaPrima.push(apontamentoMateriaPrima);
              });
              state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
            }
          }
        }
      }
      if (state.alterouQuantidadeMP) {
        try {
          const retorno = await servicoOrdemProducao.alterar(state.ordemProducao);
          if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
            await AtualizarTela();
            state.criarApontamentoProdutoAcabado = true;
            apresentarMensagemSucesso('Ordem de produção iniciada com sucesso.');
          } else {
            apresentarRetornoRequisicao(retorno);
          }
        } catch (erro) {
          if (erro instanceof Error) {
            apresentarMensagemErro(erro.message);
          } else {
            apresentarMensagemErro(String(erro));
          }
        } finally {
          ocultarBarraProgresso();
        }
      }
    }

    async function EditararApontamentoTransferenciaLote() {
      try {
        state.produtosSelecionados = [] as IDTOSelecaoProduto[];
        for (let i = 0; i < state.ordemProducao.etapasProducao.length; i += 1) {
          const etapa = state.ordemProducao.etapasProducao[i];
          for (let j = 0; j < etapa.materiasPrimas.length; j += 1) {
            const mp = etapa.materiasPrimas[j];
            if ((mp.transferirLote === true) && mp.apontamentosMateriaPrima.reduce((acc, curr) => acc + curr.quantidade, 0) !== mp.quantidade) {
              const produtoSelecionado = {} as IDTOSelecaoProduto;
              produtoSelecionado.codigoProdutoDefinicao = mp.codigoProduto;
              produtoSelecionado.codigoItem = mp.codigo;
              produtoSelecionado.quantidade = mp.quantidade;
              produtoSelecionado.estoqueRastPrevio = mp.apontamentosMateriaPrima.map((apontamento) => ({
                codigoItem: mp.codigo,
                codigoItemNotaFiscal: 0,
                codigoProdutoDefinicao: apontamento.codigoProduto,
                codigoMovimento: apontamento.codigo,
                codigoEstoque: apontamento.codigoEstoque,
                descricaoEstoque: '',
                descricao: '',
                identificador: apontamento.rastreabilidades?.[0]?.identificador || '',
                quantidade: apontamento.quantidade,
                tipo: apontamento.rastreabilidades?.[0]?.tipo || 0,
                saldo: 0,
                codigoProduto: String(apontamento.codigoProduto),
                descricaoProduto: '',
                unidade: '',
                codigoItemEstoque: apontamento.codigoEstoqueItem,
                codigo: apontamento.rastreabilidades?.[0]?.codigo || apontamento.codigoEstoqueItem,
                numeroLote: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.numeroLote || '',
                dataValidade: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.dataValidade || '',
                dataFabricacao: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.dataFabricacao || '',
                observacao: apontamento.rastreabilidades?.[0]?.observacao || '',
                dataVencimentoFormatada: '',
                dataFabricacaoFormatada: '',
                precoMaximoConsumidor: 0,
                descricaoArmamento: '',
                TipoUsoArma: ETipoUsoArma.UsoPermitido,
                numeroSerieArma: '',
                numeroSerieCano: '',
                casasDecimais: 0,
                qtdSelecionada: apontamento.quantidade,
                qtdAjuste: 0,
                qtdAjustada: 0,
                visivel: true,
                controles: [],
              }));
              state.tipoRastreabilidade = mp.tipoRastreabilidade;
              state.tipoLancamento = ETipoLancamentoRastreabilidade.Manual;
              state.codigoItemEstoque = mp.estoqueItem;
              state.alterouQuantidadeMP = true;
              state.selecaoUnica = false;
              state.lancouRastreabilidades = false;
              state.lancamentoInicialMPProducao = false;
              state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
              state.produtosSelecionados.push(produtoSelecionado);
            }
            state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
          }
        }
        if (state.produtosSelecionados.length > 0) {
          state.exibirRastreabilidade = true;
          state.tipoSelecaoRastreabilidade = 3;
          state.alterouAptoTransferenciaLote = true;
        }
      } catch (erro) {
        if (erro instanceof Error) {
          apresentarMensagemErro(erro.message);
        } else {
          apresentarMensagemErro(String(erro));
        }
        return false;
      } finally {
        ocultarBarraProgresso();
      }
      return true;
    }
    async function lancarSelecaoEstoqueRastreabilidade(lancamentos: IDTORastreabilidade[]) {
      const rastreabilidadesSelecionadas = [] as IRastreabilidade[];
      const exclusoes = [] as number[];
      lancamentos.forEach((r) => {
        if (r.qtdSelecionada > 0) {
          const selecao = {} as IRastreabilidade;
          selecao.origem = {} as IRastreabilidadeOrigem;
          selecao.codigo = r.codigo;
          selecao.codigoItemMovimento = r.codigoItem;
          selecao.identificador = r.identificador;
          if (state.lancamentoInicialMPProducao) selecao.codigoItemEstoque = r.codigoItemEstoque;
          selecao.origem.quantidade = r.qtdSelecionada;
          rastreabilidadesSelecionadas.push(selecao);
          exclusoes.push(r.codigoItem);
        }
      });
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      if (state.tipoRastreabilidade !== ETipoRastreabilidade.Nenhum) {
        retorno = await servicoRastreabilidade.excluirOrigens('PCP_ORDEM_PRODUCAO_MP', exclusoes);
        if (retorno.status !== EStatusRetornoRequisicao.Sucesso) {
          apresentarMensagemAlerta(retorno.mensagem);
          return;
        }
      }
      if (lancamentos.filter((r) => r.qtdSelecionada > 0).length > 0 && !state.lancamentoInicialMPProducao) {
        state.estoqueRastreabilidadeUtilizado = lancamentos.filter((r) => r.qtdSelecionada > 0);
        if (state.tipoRastreabilidade === ETipoRastreabilidade.Lote || state.tipoRastreabilidade === ETipoRastreabilidade.Armamento || state.tipoRastreabilidade === ETipoRastreabilidade.Outros) {
          retorno = await servicoRastreabilidade.lancarRastreabilidadeSaida('PCP_ORDEM_PRODUCAO_MP', rastreabilidadesSelecionadas.filter((r) => r.identificador !== ''));
          if (retorno.status !== EStatusRetornoRequisicao.Sucesso) {
            apresentarMensagemAlerta(retorno.mensagem);
            return;
          }
        }
      }
      retorno = await servicoRastreabilidade.excluirOrigens('PCP_ORDEM_PRODUCAO_MP', exclusoes);
      if (retorno.status !== EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemAlerta(retorno.mensagem);
        return;
      }

      if (rastreabilidadesSelecionadas.length === 0) {
        apresentarMensagemAlerta('Nenhuma rastreabilidade lançada!');
        return;
      }
      apresentarBarraProgresso();
      if (!state.lancamentoInicialMPProducao) {
        retorno = await servicoRastreabilidade.lancarRastreabilidadeSaida('PCP_ORDEM_PRODUCAO_MP', rastreabilidadesSelecionadas.filter((r) => r.identificador !== ''));
      } else {
        state.rastreabilidadeMPUtilizada = rastreabilidadesSelecionadas;
        state.lancouRastreabilidades = true;
        ocultarBarraProgresso();
      }
      if (state.tipoSelecaoRastreabilidade === 3 && state.ordemProducao.status === EStatusProducao.Pendente && !state.alterouAptoTransferenciaLote) {
        await concluirCriacaoApontamentoMp(lancamentos);
      } else if (state.tipoSelecaoRastreabilidade === 3 && state.ordemProducao.status === EStatusProducao.Pendente && state.alterouAptoTransferenciaLote) {
        await ConcluirCriacaoApontamentoMPTransferenciaLote(lancamentos);
      } else if (state.tipoSelecaoRastreabilidade === 3) {
        await ConcluirCriacaoApontamentoMPAdicionada(lancamentos);
      } else {
        await concluirCriacaoOpQtdPorLote(lancamentos);
      }
      ocultarBarraProgresso();
    }

    async function salvar() {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };

      if (state.ordemProducao.status === EStatusProducao.Produzindo) {
        if (!await CriarApontamentoMPAdicionada() || state.alterouQuantidadeMP) {
          return;
        }
      } else if (state.ordemProducao.status === EStatusProducao.Pendente) {
        if (!await EditararApontamentoTransferenciaLote() || state.alterouQuantidadeMP) {
          return;
        }
      }
      apresentarBarraProgresso();
      retorno = await servicoOrdemProducao.alterar(state.ordemProducao);
      ocultarBarraProgresso();
      await AtualizarTela();
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        emit('update:confirmacao', retorno.codigoRegistro);
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    async function AlterarEtapaProducao() {
      if (state.ordemProducao.status === EStatusProducao.Pendente) {
        ConcluirProducao();
      }
    }

    async function preencherOrdemProducao() {
      if (state.ordemProducao.codigo > 0) { return; }
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };

      apresentarBarraProgresso();
      if (props.operacao.tipoPermissaoDados === EPermissaoDados.Incluir) {
        const parametros: IParametrosConsultaOP = {} as IParametrosConsultaOP;
        parametros.codigoEmpresa = props.operacao.empresaSelecionada;
        parametros.codigoEngenharia = state.ordemProducao.codigoEngenharia;
        parametros.codigoUnidade = state.ordemProducao.codigoUnidade;
        parametros.quantidadeProduzir = state.ordemProducao.quantidadeProduzir;
        retorno = await servicoOrdemProducao.criarPorEngenharia(parametros);
      }
      ocultarBarraProgresso();

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        emit('update:confirmacao', retorno.codigoRegistro);
        computedOperacao.value.codigoRegistro = retorno.codigoRegistro;
        computedOperacao.value.tipoPermissaoDados = EPermissaoDados.Alterar;
        state.ordemProducao = await servicoOrdemProducao.obter(retorno.codigoRegistro, props.operacao.empresaSelecionada);
        await AtualizarTela();
        state.editarApontamentoMateriaPrima = true;
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    async function imprimirOrdemProducao() {
      const retornoRelatorio = await servicoOrdemProducao.imprimirOrdemProducao(state.ordemProducao.codigo);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function imprimirEtiqueta(tipo: ETipoEtiqueta) {
      telaBase.carregando = true;
      const retornoRelatorio = await servicoOrdemProducao.imprimirEtiqueta(state.ordemProducao.codigo, storeSistema.getters.codigoEmpresaOperacao(), tipo);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function imprimirMapaProducao() {
      const retornoRelatorio = await servicoOrdemProducao.imprimirMapa(state.ordemProducao.codigo);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    watch(async () => modalBase.computedVisivel, async () => {
      await AtualizarTela();
    });

    async function confirmarAtualizacaoValidadeLote() {
      if (!state.editavel || !state.ordemProducao.dataConclusao) return;

      Modal.confirm({
        title: 'Atualização de Data',
        content: 'Deseja atualizar a Data de Validade do Lote?',
        okText: 'Sim',
        cancelText: 'Não',
        onOk() {
          const dataConclusao = new Date(state.ordemProducao.dataConclusao);
          dataConclusao.setDate(dataConclusao.getDate() + (state.ordemProducao.validadeDias || 0));
          state.ordemProducao.dataValidadeLote = dataConclusao.toISOString().split('T')[0]; // Formato YYYY-MM-DD
        },
      });
    }

    // Função para recalcular as quantidades
    function recalcularProporcaoMateriasPrimasEProdutosAcabados() {
      const anterior = state.quantidadeProduzirAnterior;
      const atual = state.ordemProducao.quantidadeProduzir;
      if (!anterior || !atual || anterior === atual) return;

      const proporcao = atual / anterior;

      // Recalcula matérias-primas
      state.ordemProducao.etapasProducao.forEach((etapa) => {
        if (Array.isArray(etapa.materiasPrimas)) {
          etapa.materiasPrimas.forEach((mp) => {
            if (typeof mp.quantidade === 'number') {
              // eslint-disable-next-line no-param-reassign
              mp.quantidade = +(mp.quantidade * proporcao).toFixed(6);
              // eslint-disable-next-line no-param-reassign
              mp.custoTotal = +(mp.custoUnitario * mp.quantidade).toFixed(6);
            }
            // Recalcula matérias-primas de produto intermediário (PI)
            if (mp.produtoIntermediario && Array.isArray(mp.materiasPrimasPI)) {
              mp.materiasPrimasPI.forEach((pi) => {
                if (typeof pi.quantidade === 'number') {
                  // eslint-disable-next-line no-param-reassign
                  pi.quantidade = +(pi.quantidade * proporcao).toFixed(6);
                  // eslint-disable-next-line no-param-reassign
                  pi.custoTotal = +(pi.custoUnitario * pi.quantidade).toFixed(6);
                }
              });
            }
          });
        }
        // Recalcula produtos acabados
        if (Array.isArray(etapa.produtosAcabados)) {
          etapa.produtosAcabados.forEach((pa) => {
            if (typeof pa.quantidade === 'number') {
              // eslint-disable-next-line no-param-reassign
              pa.quantidade = +(pa.quantidade * proporcao);
              // eslint-disable-next-line no-param-reassign
              pa.custoTotal = +(pa.custoUnitario * pa.quantidade);
            }
          });
        }
      });
    }

    function onFocusQuantidadeProduzir() {
      if (state.ordemProducao.quantidadeProduzir > 0) {
        state.quantidadeProduzirAnterior = state.ordemProducao.quantidadeProduzir;
      }
    }
    async function AtualizarControlesOPConcluida() {
      const retorno = await servicoOrdemProducao.AtualizarControlesOPConcluida(state.ordemProducao);
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        emit('update:confirmacao', retorno.codigoRegistro);
        AtualizarTela();
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    async function AtualizarObsercacaoDeOPConcluida() {
      const retorno = await servicoOrdemProducao.AtualizarObservacaoDeOPConcluida(state.ordemProducao);
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        emit('update:confirmacao', retorno.codigoRegistro);
        AtualizarTela();
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }
    function onBlurQuantidadeProduzir() {
      if (state.ordemProducao.codigo > 0 && state.editavel && state.quantidadeProduzirAnterior > 0) {
        recalcularProporcaoMateriasPrimasEProdutosAcabados();
      } else if (state.ordemProducao.codigo === 0) {
        preencherOrdemProducao();
      }
    }

    function estrategiaAlteracaoObservacao() {
      if (state.ordemProducao.status === EStatusProducao.Concluido) {
        state.atualizarObservacao = true;
      }
    }

    async function reverterStatusOP() {
      const statusAlvo = state.ordemProducao.status === EStatusProducao.Produzindo ? EStatusProducao.Pendente : EStatusProducao.Produzindo;
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      retorno = await servicoOrdemProducao.ReverterMovimentoOrdemProducao(state.ordemProducao, statusAlvo);
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        emit('update:confirmacao', retorno.codigoRegistro);
        AtualizarTela();
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    async function cancelarOrdemProducao() {
      const statusAlvo = EStatusProducao.Cancelado;
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      retorno = await servicoOrdemProducao.ReverterMovimentoOrdemProducao(state.ordemProducao, statusAlvo);
      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        emit('update:confirmacao', retorno.codigoRegistro);
        AtualizarTela();
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    async function validarReversaoStatusOP() {
      if (state.ordemProducao.codigo > 0 && (state.ordemProducao.status === EStatusProducao.Produzindo || state.ordemProducao.status === EStatusProducao.Concluido)) {
        const statusAlvo = state.ordemProducao.status === EStatusProducao.Produzindo ? EStatusProducao.Pendente : EStatusProducao.Produzindo;
        Modal.confirm({
          title: 'Voltar Status da OP',
          content: `Deseja voltar o status da OP para ${statusAlvo === EStatusProducao.Produzindo ? 'Produzindo' : 'Pendente'} ?`,
          okText: 'Sim',
          cancelText: 'Não',
          async onOk() {
            await reverterStatusOP();
          },
        });
      }
    }

    async function validarCancelamentoOP() {
      if (state.ordemProducao.codigo > 0 && (state.ordemProducao.status === EStatusProducao.Produzindo || state.ordemProducao.status === EStatusProducao.Concluido)) {
        Modal.confirm({
          title: 'Cancelar Ordem de Produção',
          content: 'Deseja Cancelar a Ordem de Produção?',
          okText: 'Sim',
          cancelText: 'Não',
          async onOk() {
            await cancelarOrdemProducao();
          },
        });
      }
    }

    return {
      telaBase,
      props,
      modalBase,
      state,
      salvar,
      objetoInicial,
      EPermissaoDados,
      gradeBase,
      ECustomRenderRow,
      PreencherEngenhariaProduto,
      AlterarEtapaProducao,
      preencherOrdemProducao,
      EStatusProducao,
      imprimirMapaProducao,
      imprimirOrdemProducao,
      confirmarAtualizacaoValidadeLote,
      IniciarOrdemProducao,
      ConcluirProducao,
      criarOPComQtdePorLote,
      onFocusQuantidadeProduzir,
      onBlurQuantidadeProduzir,
      imprimirEtiqueta,
      validarConclusao,
      lancarSelecaoEstoqueRastreabilidade,
      AtualizarControlesOPConcluida,
      AtualizarObsercacaoDeOPConcluida,
      estrategiaAlteracaoObservacao,
      validarReversaoStatusOP,
      validarCancelamentoOP,
      EditararApontamentoTransferenciaLote,
      verificarAlteracaoApontamentos,
    };
  },
});
